export default __webpack_public_path__ + "static/media/InsideBlood_10.0149572f.png";